import Schema from './schema'
import itemSchema from './item.schema'

const stockOrderSchema = new Schema({
  order: itemSchema
})

export default stockOrderSchema
